import React, { useState, useContext } from 'react';
import { Navbar, NavbarBrand, NavbarToggler, Collapse } from 'reactstrap';

import { UserContext } from '../context/User';
import PublicNavigation from '../components/PublicNavigation';
import AuthNavigation from '../components/AuthNavigation';

function AppNavigation() {
  const [isOpen, toggle] = useState(false);
  const { isLoading, user } = useContext(UserContext);

  const renderNavigation = () => {
    if (isLoading) return <React.Fragment />;
    return user ? <AuthNavigation user={user} /> : <PublicNavigation />;
  };

  return (
    <Navbar color="light" light expand="md">
      <NavbarBrand href="/">The Shoeshine Guild</NavbarBrand>
      <NavbarToggler onClick={() => toggle(!isOpen)} />
      <Collapse isOpen={isOpen} navbar>
        {renderNavigation()}
      </Collapse>
    </Navbar>
  );
}

export default AppNavigation;
